import Client from './client';

export default class Disputes extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(options = {}) {
    return this.makeRequest(`${this.host}/internal/disputes`, options);
  }

  getById(id, options = {}) {
    return this.makeRequest(`${this.host}/internal/disputes/${id}`, options);
  }

  putStatusById(id, options = {}) {
    return this.makeRequest(`${this.host}/internal/disputes/${id}/status`, {
      ...options,
       method: 'PUT',
    });
  }

}
